export class User {
  public username: string;
  public idUser?: string;
  public authorities: string[];
  public id_token: string;
  public timeout: number;

  constructor(username?: string, idUser?: string, authorities?: string[], id_token?: string, timeout?: number) {
    this.username = username ? username : null;
    this.idUser = idUser ? idUser : null;
    this.authorities = authorities ? authorities : [];
    this.id_token = id_token ? id_token : null;
    this.timeout = timeout ? timeout : 0;
  }
}
